<template>
  <CRow>
    <CCol col="12">
      <CCard>
        <CCardHeader>
          <CRow>
            <CCol sm="7">
              <h4 id="traffic" class="card-title mb-0">Banner List</h4>
            </CCol>
            <CCol sm="5" class="d-none d-md-block" />
          </CRow>
        </CCardHeader>
        <CCardBody>
          <CRow>
            <CCol>
              <CButton
                color="primary"
                class="float-left mb-2 ml-3"
                @click="BannerListCreate"
              >
                Create
              </CButton>
            </CCol>
            <CCol sm="5" class="d-none d-md-block" />
            <CRow class="float-right">
              <div class="search-list">
                <CCol sm="12">
                  <CInput
                    class="float-left mb-0 mr-2"
                    placeholder="Search By Display Page"
                    v-model="request.banner_page"
                    @input="onSearch()"
                  >
                    <template #prepend-content>
                      <CIcon name="cil-magnifying-glass" />
                    </template>
                  </CInput>
                </CCol>
              </div>
            </CRow>
          </CRow>
          <CDataTable
            hover
            striped
            :items="items"
            :fields="fields"
            :items-per-page="20"
            clickable-rows
            :active-page="1"
            :pagination="false"
            @page-change="pageChange"
          >
            <template #main_desktop_image="data">
              <td>
                <img
                  :src="data.item.main_desktop_image"
                  :alt="data.item.alt_text_image"
                  width="200px"
                >
              </td>
            </template>
            <template #main_mobile_image="data">
              <td>
                <img
                  :src="data.item.main_mobile_image"
                  :alt="data.item.alt_text_image"
                  width="100px"
                >
              </td>
            </template>
            <template #language="data">
              <td>
                {{ data.item.language.toUpperCase() }}
              </td>
            </template>
            <template #action="data">
              <td>
                <div class="button-table">
                  <CButton
                    color="primary"
                    class="mb-0 mr-1"
                    @click="rowClicked(data.item.id)"
                  >
                    Edit
                  </CButton>
                  <CButton
                    color="danger"
                    class="mb-0 mr-0"
                    @click="deleteBannerList(data.item.id)"
                  >
                    Delete
                  </CButton>
                </div>
              </td>
            </template>
          </CDataTable>
          <div class="pagination-nav">
            <div
              class="pagination-btn-refresh"
              @click="getBannerList('REFRESH')"
            >
              Refresh
            </div>
            <div
              class="pagination-btn-back"
              @click="getBannerList('BACK')"
            >
              back
            </div>
            <div class="pagination-page-title">{{ request.page }}</div>
            <div
              class="pagination-btn-next"
              @click="getBannerList('NEXT')"
            >
              next
            </div>
          </div>
        </CCardBody>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
import jwt from "jsonwebtoken";
import BannerListUseCase from "./app/usecase";

export default {
  name: "BannerList",
  data() {
    return {
      items: [],
      fields: [
        { key: "id", label: "ID" },        
        { key: "main_desktop_image", label: "Desktop Banner" },
        { key: "main_mobile_image", label: "Mobile Banner" },
        { key: "alt_text_image", label: "Alt" },
        { key: "banner_page", label: "Display Page" },
        { key: "is_revamp", label: "Revamp" },
        { key: "priority", label: "Priority" },
        { key: "language", label: "Language" },
        { key: "action", label: "Action", _style: "min-width: 150px" },
      ],
      token: "Bearer " + localStorage.getItem("token"),
      request: {
        page: 1,
        per_page: 20,
        status: "ACTIVE",
        banner_page: "",
      },
      debounce: {
        timeout: 0,
        duration: 500,
      },
      searchTimeout: null,
    };
  },
  mounted() {
    this.authentication();
    this.getBannerList();
  },
  beforeDestroy() {
    clearTimeout(this.searchTimeout)
  },
  methods: {
    authentication() {
      const data = jwt.decode(localStorage.getItem("token"));
      if (
          data.account_group === "MARKETING" ||
          data.account_group === "ADMIN" ||
          data.account_group === "ADMINISTRATOR"
      ) {
        return null;
      } else {
        this.$router.push({ path: `/` });
      }
    },
    onSearch() {
      clearTimeout(this.searchTimeout)
      this.searchTimeout = setTimeout(this.searchBannerList, this.debounce.duration);
    },
    async searchBannerList() {
      try {
        await this.getBannerList()
        this.request.page = 1
      } catch (err) {
        await this.$swal.fire({
          icon: "error",
          text: err
        })
      }
    },
    async getBannerList(action) {
      try {
        this.validatePagination(action);
        const queries = Object.keys(this.request).map((key) => key + "=" + this.request[key]).join("&");
        const { data, err } = await BannerListUseCase.getAll(queries);
        if (err || data.length == 0) {
          this.validateNextPagination(action);
          this.err = err;
        } else {
          if (data) {
            window.scrollTo(0, 0);
            this.items = data.map(o => ({
              ...o,
              is_revamp: o.is_revamp ? 'Yes' : 'No',
              priority: o.priority || '-'
            }));
          }
        }
      } catch (err) {
        await this.$swal.fire({
          icon: "error",
          text: err,
        });
      }
    },
    validatePagination(action) {
      if (action === "NEXT") {
        this.request.page = this.request.page + 1;
      } else if (action === "BACK") {
        if (this.request.page > 1) {
          this.request.page = this.request.page - 1;
        }
      } else if (action === "REFRESH") {
        this.request.page = 1;
      } else {
        this.request.page = 1;
      }
    },
    validateNextPagination(action) {
      if (action === "NEXT") {
        this.request.page = this.request.page - 1;
      } else {
        this.items = [];
      }
    },
    rowClicked(item) {
      this.$router.push({ path: `/management/banner-list/${item}` });
    },
    /** @param BannerListID {number} */
    deleteBannerList(BannerListID) {
      this.$swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
      }).then(async(result) => {
        if (result.value) {
          const { err } = await BannerListUseCase.deleteOne(BannerListID)
          if (!err) {
            this.$swal.fire({
              icon: "success",
              title: "Banner List Deleted",
              showConfirmButton: false,
              timer: 2000,
            });
            this.getBannerList();
          }
          else {
            this.$swal.fire({
              icon: "error",
              title: "Oops...",
              text: err,
            });
          }
        }
      });
    },
    pageChange(val) {
      this.$router.push({ query: { page: val } });
    },
    BannerListCreate() {
      this.$router.push({ path: `/management/banner-list/create` });
    },
  },
};
</script>

<style scoped>
@import "./BannerList.css";
</style>
